import React from "react";
import {Spinner} from "reactstrap";


const FilkersLoading = () => {

	return (
		<div className="flk-loading">
			<Spinner type="grow" color="light"/>
		</div>
	);

}

export default FilkersLoading;